/* ===================== GOLDEN PAGE — Shopify App Logic ===================== */
(function(){
  const STORAGE_KEY = "gp_lang";
  const supported   = ["en","zh","ms"];

  /* ---------- EVENTS — read from DOM written by Liquid ---------- */
  /* Only upcoming events feed the hero carousel. Past ones stay in the list below. */
  function loadEventsFromDom(){
    return Array.from(document.querySelectorAll('.event-card[data-event-id]:not([data-event-when="past"])')).map((el,i) => ({
      id: el.dataset.eventId || ("ev" + (i+1)),
      mode: el.dataset.eventMode || "physical",
      day: parseInt(el.dataset.eventDay || "1", 10),
      dateISO: el.dataset.eventDate || "",
      dateLabel: el.dataset.eventDatelabel || "",
      time: el.dataset.eventTime || "",
      fee: { amount: /free/i.test(el.dataset.eventFee || "") ? 0 : 1, label: { en: el.dataset.eventFee || "", zh: el.dataset.eventFee || "", ms: el.dataset.eventFee || "" } },
      url: el.dataset.eventUrl || "",
      link: el.dataset.eventLink || "/pages/events",
      poster: el.dataset.eventPoster || "",
      i18n: { en: { title: el.dataset.eventTitle || "", location: el.dataset.eventLocation || "", organiser: el.dataset.eventOrganiser || "", desc: el.dataset.eventDesc || "" } }
    }));
  }
  window.GP_EVENTS = loadEventsFromDom();

  /* ---------- LANGUAGE ---------- */
  function detectInitialLang(){
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && supported.includes(saved)) return saved;
    const browser = (navigator.language || "en").toLowerCase();
    if (browser.startsWith("zh")) return "zh";
    if (browser.startsWith("ms")) return "ms";
    return "en";
  }
  function currentLang(){ return localStorage.getItem(STORAGE_KEY) || "en"; }
  function t(key, lang){
    const L = lang || currentLang();
    const dict = (window.GP_I18N && window.GP_I18N[L]) || (window.GP_I18N && window.GP_I18N.en) || {};
    return dict[key] != null ? dict[key] : key;
  }

  function applyLang(lang){
    const dict = (window.GP_I18N && window.GP_I18N[lang]) || (window.GP_I18N && window.GP_I18N.en) || {};
    document.documentElement.setAttribute("lang", lang);
    document.querySelectorAll("[data-i18n]").forEach(el => {
      const key = el.getAttribute("data-i18n");
      if (dict[key] != null) el.innerHTML = dict[key];
    });
    document.querySelectorAll(".lang__btn").forEach(b => {
      const active = b.dataset.lang === lang;
      b.classList.toggle("is-active", active);
      b.setAttribute("aria-pressed", active ? "true" : "false");
    });
    localStorage.setItem(STORAGE_KEY, lang);
    renderEventsHero();
    renderAdmin();
    setWhatsAppLink();
  }

  /* ---------- WHATSAPP ---------- */
  function setWhatsAppLink(){
    const a = document.getElementById("wa-float");
    if (!a) return;
    const num = (window.gpTheme && window.gpTheme.whatsappNumber) || "60312345678";
    const msg = t("wa.prefill");
    a.href = "https://wa.me/" + num + "?text=" + encodeURIComponent(msg);
  }

  /* ---------- EVENTS HERO CAROUSEL ---------- */
  let heroIdx = 0;
  let heroTimer = null;

  function renderEventsHero(){
    const track = document.querySelector(".events-track");
    const dotsBox = document.querySelector(".events-dots");
    if (!track) return;
    const lang = currentLang();
    const evs = window.GP_EVENTS || [];
    const shell = document.querySelector(".hero__events");
    if (evs.length === 0) {
      // Nothing upcoming - hide the whole card rather than leave an empty box
      track.innerHTML = "";
      if (dotsBox) dotsBox.innerHTML = "";
      if (shell) shell.hidden = true;
      return;
    }
    if (shell) shell.hidden = false;

    track.innerHTML = evs.map((e, i) => {
      const x = e.i18n[lang] || e.i18n.en;
      const badgeClass = e.mode === "online" ? "event-badge--online" : "event-badge--physical";
      const badgeText = e.mode === "online" ? t("events.online", lang) : t("events.physical", lang);
      const feeText = e.fee.amount === 0 ? t("events.free", lang) : (e.fee.label[lang] || e.fee.label.en || "");
      // Poster plus the four facts, and no description. The button opens this
      // event on the Events page rather than the registration form, so people
      // read the full write-up before signing up.
      const poster = e.poster
        ? `<div class="event-slide__poster"><img src="${escapeHtml(e.poster)}" alt="${escapeHtml(x.title)}" loading="lazy" /></div>`
        : "";
      return `
        <article class="event-slide ${i === heroIdx ? "is-active" : ""}" data-idx="${i}">
          <span class="event-badge ${badgeClass}">${badgeText}</span>
          <h3>${x.title}</h3>
          ${poster}
          <div class="event-slide__meta">
            <span>📅 ${formatDate(e, lang)}</span>
            <span>🕐 ${e.time}</span>
            <span>📍 ${x.location}</span>
            <span>💳 ${feeText}</span>
          </div>
          <a href="${escapeHtml(e.link)}" class="event-slide__cta">${t("events.viewDetails", lang)} →</a>
        </article>
      `;
    }).join("");

    if (dotsBox){
      dotsBox.innerHTML = evs.map((_, i) =>
        `<button class="event-dot ${i === heroIdx ? "is-active" : ""}" data-idx="${i}" aria-label="Event ${i+1}"></button>`
      ).join("");
      dotsBox.querySelectorAll(".event-dot").forEach(d => {
        d.addEventListener("click", () => goHero(parseInt(d.dataset.idx, 10)));
      });
    }
  }
  function goHero(i){
    const evs = window.GP_EVENTS || [];
    if (evs.length === 0) return;
    heroIdx = ((i % evs.length) + evs.length) % evs.length;
    renderEventsHero();
    resetHeroTimer();
  }
  function resetHeroTimer(){
    if (heroTimer) clearInterval(heroTimer);
    if ((window.GP_EVENTS || []).length > 1) {
      heroTimer = setInterval(() => goHero(heroIdx + 1), 6000);
    }
  }
  function bindHeroArrows(){
    document.querySelectorAll("[data-hero-arrow]").forEach(btn => {
      btn.addEventListener("click", () => goHero(heroIdx + (btn.dataset.heroArrow === "next" ? 1 : -1)));
    });
  }

  function formatDate(e, lang){
    if (e.dateLabel) return e.dateLabel;   // multi-day events: shown as typed
    if (!e.dateISO) return "";
    const d = new Date(e.dateISO + "T00:00:00");
    return d.toLocaleDateString(
      lang === "zh" ? "zh-CN" : lang === "ms" ? "ms-MY" : "en-MY",
      { weekday: "long", day: "numeric", month: "long", year: "numeric" }
    );
  }

  /* ---------- PILLAR ADMIN ---------- */
  const ITEMS_KEY = p => `gp_items_${p}`;
  function loadItems(p){ try{ return JSON.parse(localStorage.getItem(ITEMS_KEY(p)) || "[]"); } catch(_){ return []; } }
  function saveItems(p, items){ localStorage.setItem(ITEMS_KEY(p), JSON.stringify(items)); }

  function renderAdmin(){
    const root = document.querySelector("[data-admin-pillar]");
    if (!root) return;
    const pillar = root.dataset.adminPillar;
    const lang = currentLang();
    const items = loadItems(pillar);

    const listEl = root.querySelector(".admin-list");
    const countEl = root.querySelector("[data-admin-count]");
    if (countEl) countEl.textContent = items.length + " " + t("admin.savedCount", lang);
    if (!listEl) return;

    if (items.length === 0){
      listEl.innerHTML = `<div class="admin-empty">${t("admin.empty", lang)}</div>`;
      return;
    }
    listEl.innerHTML = items.map(it => `
      <article class="admin-item">
        <div class="admin-item__head">
          <div>
            <h4>${escapeHtml(it.name)}</h4>
            <span class="admin-item__price">${escapeHtml(it.price)}</span>
          </div>
          <button class="admin-item__del" data-del="${it.id}" aria-label="${t("admin.delete", lang)}" title="${t("admin.delete", lang)}">✕</button>
        </div>
        <p>${escapeHtml(it.desc)}</p>
        ${(it.contact || it.category) ? `
          <div class="admin-item__meta">
            ${it.category ? `<span>🏷 ${escapeHtml(it.category)}</span>` : ""}
            ${it.contact  ? `<span>📞 ${escapeHtml(it.contact)}</span>`  : ""}
          </div>` : ""}
      </article>
    `).join("");

    listEl.querySelectorAll("[data-del]").forEach(btn => {
      btn.addEventListener("click", () => {
        const next = loadItems(pillar).filter(i => i.id !== btn.dataset.del);
        saveItems(pillar, next);
        renderAdmin();
      });
    });
  }

  function bindAdmin(){
    const root = document.querySelector("[data-admin-pillar]");
    if (!root) return;
    const pillar = root.dataset.adminPillar;
    const form = root.querySelector("form.admin-form");
    const clearBtn = root.querySelector("[data-admin-clear]");
    if (form){
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        const data = new FormData(form);
        const name = (data.get("name") || "").toString().trim();
        const desc = (data.get("desc") || "").toString().trim();
        const price = (data.get("price") || "").toString().trim();
        if (!name || !desc || !price){ alert(t("admin.required", currentLang())); return; }
        const items = loadItems(pillar);
        items.unshift({
          id: "it_" + Date.now() + "_" + Math.random().toString(36).slice(2,7),
          name, desc, price,
          contact: (data.get("contact") || "").toString().trim(),
          category: (data.get("category") || "").toString().trim(),
          createdAt: new Date().toISOString()
        });
        saveItems(pillar, items);
        form.reset();
        renderAdmin();
      });
    }
    if (clearBtn){
      clearBtn.addEventListener("click", () => {
        if (!confirm(t("admin.confirmClear", currentLang()))) return;
        saveItems(pillar, []);
        renderAdmin();
      });
    }
  }

  function escapeHtml(s){
    return String(s).replace(/[&<>"']/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;","'":"&#39;"})[c]);
  }

  /* The description comes from a textarea, so its newlines are real. Keep them
     visible instead of letting HTML collapse the whole thing into one block. */
  function nl2br(s){
    return escapeHtml(s == null ? "" : s)
      .replace(/\r\n?/g, "\n")
      .replace(/\n{2,}/g, "<br><br>")
      .replace(/\n/g, "<br>");
  }

  /* ---------- IMAGE BANNER SLIDESHOW ---------- */
  function bindBanners(){
    document.querySelectorAll(".gp-banner--slideshow").forEach(banner => {
      const slides = banner.querySelectorAll(".gp-banner__img--desktop");
      const dots   = banner.querySelectorAll(".gp-banner__dot");
      if (slides.length < 2) return;

      const secs = parseInt(banner.dataset.bannerInterval, 10);
      const wait = (isNaN(secs) ? 6 : secs) * 1000;
      let i = 0, timer = null;

      function show(n){
        i = (n + slides.length) % slides.length;
        slides.forEach((s, k) => s.classList.toggle("is-active", k === i));
        dots.forEach((d, k) => d.classList.toggle("is-active", k === i));
      }
      function start(){ stop(); timer = setInterval(() => show(i + 1), wait); }
      function stop(){ if (timer) { clearInterval(timer); timer = null; } }

      dots.forEach((dot, k) => {
        dot.addEventListener("click", () => { show(k); start(); });
      });

      // Pause while the pointer rests on the banner, and while the tab is hidden.
      banner.addEventListener("mouseenter", stop);
      banner.addEventListener("mouseleave", start);
      document.addEventListener("visibilitychange", () => {
        if (document.hidden) stop(); else start();
      });

      show(0);
      start();
    });
  }

  /* ---------- PROVIDER LOGOS ---------- */
  /* Size a logo by the area it covers rather than by its height, so a square
     mark and a wide wordmark carry the same visual weight. Mirrors the build
     step, and also catches logos uploaded later whose shape we can't know up
     front. */
  const LOGO_AREA = 3400;   /* about 58x58 */
  const LOGO_MIN_H = 34, LOGO_MAX_H = 70, LOGO_MAX_W = 160;

  function sizeLogo(img){
    const w = img.naturalWidth, h = img.naturalHeight;
    if (!w || !h) return;
    const ratio = w / h;
    let height = Math.sqrt(LOGO_AREA / ratio);
    if (height * ratio > LOGO_MAX_W) {
      // Very wide wordmark: the width cap decides. Applying the minimum height
      // here would push it past max-width and the browser would letterbox it
      // smaller than intended.
      height = LOGO_MAX_W / ratio;
    } else {
      height = Math.min(LOGO_MAX_H, Math.max(LOGO_MIN_H, height));
    }
    img.style.height = Math.round(Math.max(height, 16)) + "px";
  }

  function sizeAllLogos(){
    document.querySelectorAll(".listing-card__logo img").forEach(img => {
      if (img.complete) sizeLogo(img);
      else img.addEventListener("load", () => sizeLogo(img), { once: true });
    });
  }

  /* Cards with no logo file show the provider's initials, but still carry the
     filename a logo WOULD use. Probe for it: if someone has since uploaded
     that file to the theme assets, swap the image in. Nothing to edit in the
     markup, and a missing file leaves the monogram untouched. */
  function bindProviderLogos(){
    document.querySelectorAll("[data-logo-try]").forEach(box => {
      const urls = (box.dataset.logoTry || "").split("|").filter(Boolean);
      if (!urls.length) return;

      (function attempt(i){
        if (i >= urls.length) return;
        const probe = new Image();
        probe.onload = () => {
          if (!probe.naturalWidth) return attempt(i + 1);
          box.textContent = "";
          box.classList.remove("listing-card__logo--mono");
          probe.loading = "lazy";
          probe.alt = "";
          box.appendChild(probe);
          sizeLogo(probe);
        };
        probe.onerror = () => attempt(i + 1);
        probe.src = urls[i];
      })(0);
    });
  }

  /* ---------- GALLERY ALBUMS ---------- */
  /* A gallery card holding several photos of one event. Arrows, dots and swipe
     move between them; single-photo cards have no stage controls at all. */
  function bindGalleryAlbums(){
    document.querySelectorAll("[data-gallery-album]").forEach(stage => {
      const slides = stage.querySelectorAll("img[data-gal-slide]");
      if (slides.length < 2) return;
      const dots    = stage.querySelectorAll(".gallery-item__dot");
      const counter = stage.querySelector("[data-gal-current]");
      let i = 0;

      function show(n){
        i = (n + slides.length) % slides.length;
        slides.forEach((s, k) => s.classList.toggle("is-active", k === i));
        dots.forEach((d, k) => d.classList.toggle("is-active", k === i));
        if (counter) counter.textContent = String(i + 1);
      }

      const prev = stage.querySelector("[data-gal-prev]");
      const next = stage.querySelector("[data-gal-next]");
      if (prev) prev.addEventListener("click", () => show(i - 1));
      if (next) next.addEventListener("click", () => show(i + 1));
      dots.forEach((d, k) => d.addEventListener("click", () => show(k)));

      // Swipe on phones, where the arrows are the only other way through.
      let startX = null;
      stage.addEventListener("touchstart", e => { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener("touchend", e => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1);
        startX = null;
      }, { passive: true });

      show(0);
    });
  }

  /* ---------- LANG BUTTONS + MENU + SCROLL ---------- */
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".lang__btn");
    if (btn) applyLang(btn.dataset.lang);
  });

  const toggle = document.querySelector(".menu-toggle");
  const nav    = document.querySelector(".nav");
  if (toggle && nav){
    toggle.addEventListener("click", () => {
      const open = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
    nav.querySelectorAll("a").forEach(a => {
      a.addEventListener("click", () => {
        nav.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
      });
    });
  }

  const sections = document.querySelectorAll("section[id]");
  const navLinks = document.querySelectorAll(".nav a");
  function onScroll(){
    const y = window.scrollY + 120;
    let current = sections[0] ? sections[0].id : "home";
    sections.forEach(s => { if (s.offsetTop <= y) current = s.id; });
    navLinks.forEach(a => {
      const href = a.getAttribute("href") || "";
      a.style.borderBottomColor = (href === "#" + current || href.endsWith("#" + current))
        ? "var(--gp-yellow)" : "transparent";
    });
  }
  window.addEventListener("scroll", onScroll, { passive: true });

  /* ---------- INIT ---------- */
  function init(){
    bindHeroArrows();
    bindBanners();
    bindProviderLogos();
    sizeAllLogos();
    bindGalleryAlbums();
    bindAdmin();
    applyLang(detectInitialLang());
    resetHeroTimer();
    onScroll();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
